import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './NotFoundPage.css';

const NotFoundPage = () => {
  useSeo({
    title: 'Page non trouvée · Vie et Couleurs · Artisan Nantes',
    description: 'La page que vous recherchez n\'existe pas. Retournez à l\'accueil pour découvrir nos services de peinture, couverture et ravalement à Nantes.',
    canonical: 'https://www.vie-et-couleurs.fr/404'
  });

  return (
    <div className="not-found-page">
      <div className="not-found-container">
        <div className="error-code">
          <h1>404</h1>
        </div>
        
        <div className="error-message">
          <h2>Oups ! Page introuvable</h2>
          <p>
            La page que vous recherchez n'existe pas ou a été déplacée. 
            Retournez à l'accueil pour découvrir nos services.
          </p>
        </div>

        <div className="back-button">
          <Link to="/" className="btn btn-primary">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
